module.exports = __webpack_public_path__ + "img/disrate.215b0c9a.svg";